import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import FormInputText from '../../../../common/Forms/FormTextField';
import CMPFormInputText from '../../../../common/Forms/CMPFormTextField';
import { useDispatch } from 'react-redux';
import {
  setRevisionGoals1,
  setRevisionGoals2,
  setRevisionObjectives1,
  setRevisionObjectives2,
  setRevisionTargetDate1,
  setRevisionTargetDate2,
  setRevisionCompletedOn1,
  setRevisionCompletedOn2,
} from '../../../../../redux/episode/cmpTab/cmpForm/cmpSlice';
import { CmpTitle } from '../../../../ui/styled';

const CmpRevison = (props) => {
  const dispatch = useDispatch();
  const { control, register } = props;
  return (
    <>
      <Grid item xs={12}>
        <Typography pt={2} align="center" variant='h5'>CMP Revisions</Typography>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <CmpTitle variant='h6'>Goals</CmpTitle>
          <FormInputText
            name='revisionGoals1'
            type='text'
            control={control}
            multiline={true}
            //rows={3.5}
            register={register('revisionGoals1', {
              onBlur: (e) => dispatch(setRevisionGoals1(e.target.value)),
            })}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <CmpTitle variant='h6'>Objectives</CmpTitle>
          <FormInputText
            name='revisionObjectives1'
            type='text'
            control={control}
            multiline={true}
            //rows={3.5}
            register={register('revisionObjectives1', {
              onBlur: (e) => dispatch(setRevisionObjectives1(e.target.value)),
            })}
          />          
        </Grid>
        <Grid item xs={12} sm={4}>
          <CmpTitle variant='h6'>Projected Target Dates</CmpTitle>
          <CMPFormInputText
            name='revisionTargetDate1'
            type='date'
            control={control}
            shrink={true}
            register={register('revisionTargetDate1', {
              onBlur: (e) => dispatch(setRevisionTargetDate1(e.target.value)),
            })}
            label='Target Date'
          />
          <CMPFormInputText
            name='revisionCompletedOn1'
            type='date'
            control={control}
            shrink={true}
            register={register('revisionCompletedOn1', {
              onBlur: (e) =>
                dispatch(setRevisionCompletedOn1(e.target.value)),
            })}
            label='Completed On'
          />          
        </Grid>  
        <Grid item xs={12} sm={4}>
          <FormInputText
            name='revisionGoals2'
            type='text'
            control={control}
            multiline={true}
            //rows={3.5}
            register={register('revisionGoals2', {
              onBlur: (e) => dispatch(setRevisionGoals2(e.target.value)),
            })}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <FormInputText
            name='revisionObjectives2'
            type='text'
            control={control}
            multiline={true}
            //rows={3.5}
            register={register('revisionObjectives2', {
              onBlur: (e) => dispatch(setRevisionObjectives2(e.target.value)),
            })}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <CMPFormInputText
            name='revisionTargetDate2'
            type='date'
            control={control}
            shrink={true}
            register={register('revisionTargetDate2', {
              onBlur: (e) => dispatch(setRevisionTargetDate2(e.target.value)),
            })}
            label='Target Date'
          />
          <CMPFormInputText
            name='revisionCompletedOn2'
            type='date'
            control={control}
            shrink={true}
            register={register('revisionCompletedOn2', {
              onBlur: (e) =>
                dispatch(setRevisionCompletedOn2(e.target.value)),
            })}
            label='Completed On'
          />
        </Grid>
      </Grid>
    </>
  );
};

export default CmpRevison;
